import { createFileRoute } from '@tanstack/react-router'
import { WorkflowBuilder } from '@/features/workflows/workflow-builder'
import { VoiceInputProvider } from '@workspace/ui/components/voice-input-context'

function WorkflowBuilderPage() {
  return (
    <VoiceInputProvider enabled={false}>
      <WorkflowBuilder />
    </VoiceInputProvider>
  )
}

export const Route = createFileRoute(
  '/_authenticated/_organization/workflows/$workflowId'
)({
  component: WorkflowBuilderPage,
})
